export const baseUrl = "https://theeliteenterprise.in/_API/";
